<ng-container>
    <!-- Navigation -->
    <fuse-vertical-navigation
        class="bg-white border border-gray-200 border-t-0 border-l-0 border-r-1 border-b-0 print:hidden main_sidebar"
        [appearance]="navigationAppearance" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'"
        [navigation]="navigation" [opened]="!isScreenSmall">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center justify-center h-14">
                <a routerLink="/dashboard">
                    <img *ngIf="settingsData && settingsData?.imagePath && settingsData?.logo"
                        class="w-8 cursor-pointer" [src]="settingsData?.imagePath + settingsData?.logo"
                        [alt]="settingsData?.site_name">
                </a>

                <ngx-skeleton-loader *ngIf="!settingsData || !settingsData?.imagePath" class="lh-1" [theme]="{
                      width: '32px',
                      height: '32px',
                      'margin': '13px 13px 0',
                      'padding':'13px'
                    }"></ngx-skeleton-loader>
            </div>
        </ng-container>

        <ng-container fuseVerticalNavigationFooter>
            <!-- Integrations -->
            <div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-primary-300 rounded"
                *ngIf="profileData">
                <div class="fuse-vertical-navigation-item flex items-center px-5 py-2.5"
                    [tooltip]="'MENU.INTRGARTIONS' | translate" routerLink="/integrations"
                    [class.fuse-vertical-navigation-item-active]="activeParam?.includes('integrations')">
                    <ng-container>
                        <mat-icon class="fuse-vertical-navigation-item-icon icon-size-6 mr-4"
                            [svgIcon]="'heroicons_outline:app-integrations'"></mat-icon>

                    </ng-container>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title footer_item">
                            <span [ngClass]="">
                                {{'MENU.INTRGARTIONS' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- subscription -->
            <div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-primary-300 rounded"
                *ngIf="profileData">
                <div class="fuse-vertical-navigation-item flex items-center px-5 py-2.5"
                    [tooltip]="'BILLING_PAGE.SUBSCRIPTION' | translate" routerLink="/manage/subscription"
                    [class.fuse-vertical-navigation-item-active]="activeParam?.includes('subscription')">
                    <ng-container>
                        <mat-icon class="fuse-vertical-navigation-item-icon icon-size-6 mr-4"
                            [svgIcon]="'heroicons_outline:credit-card'"></mat-icon>

                    </ng-container>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title footer_item">
                            <span [ngClass]="">
                                {{'BILLING_PAGE.SUBSCRIPTION' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- settings -->
            <div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-primary-300 rounded"
                *ngIf="profileData">
                <div class="fuse-vertical-navigation-item flex items-center px-5 py-2.5"
                    [tooltip]="'MENU.SETTINGS' | translate" [routerLink]="'/account/settings'"
                    [class.fuse-vertical-navigation-item-active]="activeParam?.includes('account/settings') && !activeParam?.includes('/account/settings/email-accounts')">
                    <ng-container>
                        <mat-icon class="fuse-vertical-navigation-item-icon mr-4 icon-size-6"
                            [svgIcon]="'heroicons_outline:cog'"></mat-icon>

                    </ng-container>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title footer_item">
                            <span [ngClass]="">
                                {{'MENU.SETTINGS' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Item template -->
    <ng-template #itemTemplate>

        <!-- Icon -->
        <ng-container *ngIf="item.icon">
            <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon"
                [svgIcon]="item.icon"></mat-icon>
        </ng-container>
        <ng-container *ngIf="!item.icon && item.classes?.icon">
            <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon"></mat-icon>
        </ng-container>

        <!-- Title & Subtitle -->
        <div class="fuse-vertical-navigation-item-title-wrapper">
            <div class="fuse-vertical-navigation-item-title">
                <span [ngClass]="item.classes?.title">
                    {{item.title}}
                </span>
            </div>
            <ng-container *ngIf="item.subtitle">
                <div class="fuse-vertical-navigation-item-subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{item.subtitle}}
                    </span>
                </div>
            </ng-container>
        </div>

        <!-- Badge -->
        <ng-container *ngIf="item.badge">
            <div class="fuse-vertical-navigation-item-badge">
                <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
                    {{item.badge.title}}
                </div>
            </div>
        </ng-container>

    </ng-template>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0">
        <!-- Header -->
        <div
            class="relative flex flex-0 items-center w-full h-14 px-5 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
            <div class="flex items-center pr-2 ml-0">
                <!-- Navigation toggle button -->
                <button class="md:hidden inline-flex" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                </button>
                <!-- Navigation appearance toggle button -->
                <button class="hidden" mat-icon-button (click)="toggleNavigationAppearance()">
                    <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
                </button>
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto space-x-0.5 sm:space-x-2">
                <div class="bg-red-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-red-500 text-red-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'offline'">
                    <p class="font-bold">Connection lost! You are not connected to internet.</p>
                </div>
                <div class="bg-yellow-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-yellow-500 text-yellow-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'connecting'">
                    <p class="font-bold">Please wait connection is being restored.</p>
                </div>
                <div class="bg-green-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-green-500 text-green-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'online'">
                    <p class="font-bold">You are now back online.</p>
                </div>
                <div *ngIf="settingsData && settingsData?.is_master_account"
                    class="bg-gradient-to-r from-[#F5E8B7] to-[#FFCD4B] text-gray rounded px-2 py-0.5 text-sm">
                    {{"GENERAL.MASTER_ACCOUNT" | translate}}
                </div>
                <languages></languages>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <user></user>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

    </div>
</ng-container>